import useSWR from 'swr'

import { composeFetch, composeParser } from '@library/http'
import { addPath, composeRequest, setServiceUrl } from '@library/http/requests'

import { activeMenusResponseValidator } from './activeMenusResponseValidator'
import { transformResponse } from './transformResponse'
import { ActiveMenusGeneralInfo } from './types'

export const activeMenusRequest = composeRequest(setServiceUrl('menu', 2), addPath('menus/active'))

export const fetchActiveMenus = composeFetch(
  activeMenusRequest,
  composeParser((response) => response.json(), activeMenusResponseValidator, transformResponse),
)

/**
 * Return generic information about currently active menus
 */
export const useActiveMenusGeneralInfo: () => {
  error?: Error
  menus?: ActiveMenusGeneralInfo
} = () => {
  const { data: menus, error } = useSWR<ActiveMenusGeneralInfo, Error>(
    'menu/v2/menus/active',
    fetchActiveMenus,
    // Treat the menus info as an immutable resource, which is not changed
    // within user's session
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  )

  if (error) {
    return { error }
  }

  return { menus }
}
